import { render, staticRenderFns } from "./register.vue?vue&type=template&id=4c57fea3&scoped=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"
import style0 from "./register.vue?vue&type=style&index=0&id=4c57fea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57fea3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular,VSnackbar})
